import { render, staticRenderFns } from "./AprovacaoCompraDetalhesProduto.vue?vue&type=template&id=20f43534&"
import script from "./AprovacaoCompraDetalhesProduto.vue?vue&type=script&lang=js&"
export * from "./AprovacaoCompraDetalhesProduto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports